import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Button } from 'primereact/button';
const ProductMedia = ({ product }) => {
    const images = [product.image, ...JSON.parse(product.images || '[]')];
    const carouselRef = useRef();
    return (
        <div className="rounded-md w-full p-1">
            <div className="store-prod-media">
                <div className="flex items-center"
                    style={{
                        direction: "initial"
                    }}
                >
                    <div className="mb-40 mx-1 hidden lg:block">
                        <Button outlined rounded severity="secondary" icon={<span className="material-symbols-outlined">chevron_backward</span>}
                            onClick={() => {
                                carouselRef.current.onClickPrev();
                            }}
                            style={{
                                height: 40,
                                width: 40
                            }}
                        />
                    </div>
                    <Carousel
                        ref={carouselRef}
                        infiniteLoop
                        showThumbs
                        showArrows={false}
                        showStatus={false}
                        showIndicators={false}
                        emulateTouch={false}
                    >
                        {
                            images.map((item, index) => {
                                return (
                                    <img key={index} src={item} alt={item} className='rounded-md w-100' />
                                );
                            })
                        }
                    </Carousel>
                    <div className="mb-40 mx-1 hidden lg:block">
                        <Button outlined rounded severity="secondary" icon={<span className="material-symbols-outlined">chevron_forward</span>}
                            onClick={() => {
                                carouselRef.current.onClickNext();
                            }}
                            style={{
                                height: 40,
                                width: 40
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

ProductMedia.propTypes = {
    product: PropTypes.object.isRequired,
};

export default ProductMedia;
